import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styles from '@/lib/components/PaymentPlan/PaymentPlan.module.scss';

const InstalmentRadioGroup = ({ instalmentsOptions, selectedInstalment, setSelectedInstalment, paymentData }) => {
    const { t } = useTranslation();
    const handleChange = React.useCallback((e) => {
        setSelectedInstalment(e.target.value);
    }, [setSelectedInstalment]);
    return (
        <>
            {instalmentsOptions.map((instalment) => (
                <div className={`${styles.instalment_radio} ${selectedInstalment == instalment.value ? styles.instalment_radio_selected : styles.instalment_radio_regular}`}
                    key={instalment.value}
                >
                    <input
                        id={`instalment_${instalment.value}`}
                        type='radio'
                        name='instalment'
                        value={instalment.value}
                        onChange={handleChange}
                        checked={selectedInstalment == instalment.value}
                    />
                    <div className={styles.field_input_label_radio_checkbox}>
                        <label htmlFor={`instalment_${instalment.value}`} className={styles.label_container}>
                            <div>
                                <span>
                                    {instalment.label}
                                </span>
                            </div>
                            <div>
                                <span className={styles.label_amount}>
                                    {t('price.' + paymentData?.currency, {
                                        count: instalment?.amount,
                                    })}
                                </span>
                                <span className={styles.label_instalment}>
                                    {`/${t('instalment')}`}
                                </span>
                            </div>
                        </label>
                    </div>
                </div>
            ))}
        </>
    );
};

InstalmentRadioGroup.propTypes = {
    instalmentsOptions: PropTypes.array,
    selectedInstalment: PropTypes.number,
    setSelectedInstalment: PropTypes.func,
    paymentData: PropTypes.object,
};

export default InstalmentRadioGroup;
